export default {
  MORTGAGE_STYLE: "5ea9e68d-4680-11e9-82f6-0242ac120002",
  STRAIGHT_LINE: "62d4a044-4680-11e9-82f6-0242ac120002",
  AGENCY_FLOATER: "65a393e5-4680-11e9-82f6-0242ac120002",
  INTEREST_ONLY: "68b0cd1f-4680-11e9-82f6-0242ac120002",
  STRAIGHT_LINE_CUSTOM_AMORT: "d358209d-4680-11e9-82f6-0242ac120002"
};

export const amortizationTypeList = [
  { name: "Interest Only", value: "68b0cd1f-4680-11e9-82f6-0242ac120002" },
  { name: "Mortgage Style", value: "5ea9e68d-4680-11e9-82f6-0242ac120002" },
  // the following is actually Straight Line (Custom) but the client wants "Straight Line" as the label
  { name: "Straight Line", value: "d358209d-4680-11e9-82f6-0242ac120002" },
  { name: "Agency Floater", value: "65a393e5-4680-11e9-82f6-0242ac120002" }
];
